import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  styled,
} from "@mui/material";
import axios from "axios";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  height: "5vh",
  "& .MuiInputLabel-root": {
    color: "grey", // Default label color
    opacity: 1,
    top: "-0.5rem",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#242424",
    fontWeight: "600",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "black" }, // Default border color
    "&:hover fieldset": { borderColor: "black" }, // Border color on hover
    "&.Mui-focused fieldset": { borderColor: "#55d6aa" }, // Border color when focused
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    backgroundColor: "azure",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    top: 0,
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  height: "5vh",
  "& .MuiSelect-select": {
    fontSize: "1rem",
    display: "flex",
    alignItems: "center",
  },
}));



function DropDownList({ label, check }) {
  const [value, setValue] = useState("");
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    axios
      .get("https://restcountries.com/v3.1/all?fields=name,idd,flags")
      .then((response) => {
        const sortedCountries = response.data
          .map((country) => ({
            name: country.name.common,
            isdCode: country.idd?.root + (country.idd?.suffixes?.[0] || ""),
            flag: country.flags.png,
          }))
          .sort((a, b) => a.name.localeCompare(b.name));

        setCountries(sortedCountries);
      })
      .catch((error) => console.error("Error fetching country data:", error));
  }, []);

  const StyledMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: "30vh",
        width: check !== "1" ? "10vw" : "7vw",
        overflowY: "auto",
        backgroundColor: "#f8f8f8",
        "& .MuiMenuItem-root": {
          fontSize: "1rem",
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        },
      },
    },
  };


  return (
    <StyledFormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <StyledSelect
        value={value}
        onChange={(e) => setValue(e.target.value)}
        MenuProps={StyledMenuProps}
        PaperProps = {{
          sx: {
            width: check !== "1" ? "8vw" : "10vw", 
          }
        }}
      >
        <MenuItem value="">None</MenuItem>
        {Object.values(countries)
          .filter(
            (country) =>
              country.isdCode &&
              country.isdCode.trim() !== "" &&
              country.isdCode.toLowerCase() !== "undefined" // Remove "undefined" as a string
          )
          .sort((a, b) =>
            check === "1"
              ? (parseInt(a.isdCode.replace(/\D/g, ""), 10) || 0) -
                (parseInt(b.isdCode.replace(/\D/g, ""), 10) || 0)
              : 0
          )
          .map((country) => (
            <MenuItem
              key={country.name}
              value={check !== "1" ? country.name : country.isdCode}
            >
              {/* Show Country Name or ISD Code */}
              {check !== "1" ? country.name : country.isdCode}

              {/* Show Flag for respective country */}
              {country.flag && (
                <img
                  src={country.flag}
                  alt={country.name}
                  style={{
                    width: "1.2rem",
                    height: "0.8rem",
                    marginLeft: "1rem",
                  }}
                />
              )}
            </MenuItem>
          ))}
      </StyledSelect>
    </StyledFormControl>
  );
}

export default DropDownList;
